import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";

import AddSlideNewIcon from "../../images/AddSlideNewIcon.svg";
// import { getEdtailData, removeEdtailData } from "../../utils";
import "../../css/editor.scss";
import ValueContext from "../../utils/contextAPI/contextAPI";

import {
  createNewPage,
  createNewPageUpdate,
  createNewChildSlide,
  AddMasterSlideToDeck,
} from "../../services/apis";
import {
  addNewChildSlide,
  navigateToPrevChildAndParent,
  navigateToNextChildAndFromParent,
  inParent,
  lastChild,
} from "./ChildSlideCrND";

export default function SubSlide({
  slideID,
  setSlideID,
  currentSlide,
  setCurrentSlide,
  editor,
  appData,
  slideCount,
  childSlideCount,
  setChildSlideCount,
  navigate,
  loadSuccess,
  setLoadSuccess,
  setSaveLoading,
  setOpenPopover,
}) {
  return (
    <div
      style={{ display: "flex" }}
      className="parent-Slide"
      onClick={() =>
        addNewChildSlide(
          slideID,
          setSlideID,
          currentSlide,
          setCurrentSlide,
          editor,
          appData,
          slideCount,
          childSlideCount,
          setChildSlideCount,
          navigate,
          setSaveLoading,
          setLoadSuccess,
          loadSuccess,
          setOpenPopover
        )
      }
    >
      <img src={AddSlideNewIcon} alt="AddSlideNewIcon" />
      <div>
        <h2>Sub-slide</h2>
      </div>
    </div>
  );
}
